import React, { useState, useRef, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { PiUserThin } from 'react-icons/pi';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/AccountDropdown.module.css';
import { fetchUser } from '../services/user';
import type { UserDTO } from '../dto/UserDTO';

export const AccountDropdown: React.FC = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const storedUserName = localStorage.getItem('userName');
  const [open, setOpen] = useState(false);
  const toggleRef = useRef<HTMLDivElement>(null);

  // Track whether the user has a storeName (admin)
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!token || !storedUserName) {
      setIsAdmin(false);
      return;
    }

    fetchUser(storedUserName)
      .then((res) => {
        const user: UserDTO = res.data;
        const adminFlag = Boolean(user.storeName);
        setIsAdmin(adminFlag);
      })
      .catch((err) => {
        setIsAdmin(false);
      });
  }, [token, storedUserName]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        open &&
        toggleRef.current &&
        !toggleRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [open]);

  const menu = (
    <Dropdown.Menu
      show
      align="end"
      className={styles.menu}
      style={{
        position: 'absolute',
        top: (toggleRef.current?.getBoundingClientRect().bottom ?? 0) + 8,
        left: (toggleRef.current?.getBoundingClientRect().right ?? 0) - 140,
        zIndex: 9999,
        minWidth: 160,
      }}
    >
      {token ? (
        <>
          {isAdmin && (
            <>
              <Dropdown.Item
                onClick={() => {
                  setOpen(false);
                  navigate('/admin');
                }}
              >
                Admin Dashboard
              </Dropdown.Item>
              <Dropdown.Divider />
            </>
          )}
          <Dropdown.Item
            onClick={() => {
              setOpen(false);
              navigate('/user');
            }}
          >
            My Account
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item
            onClick={() => {
              localStorage.removeItem('token');
              localStorage.removeItem('userName');
              setOpen(false);
              navigate('/login');
            }}
          >
            Logout
          </Dropdown.Item>
        </>
      ) : (
        <Dropdown.Item
          onClick={() => {
            setOpen(false);
            navigate('/login');
          }}
        >
          Login
        </Dropdown.Item>
      )}
    </Dropdown.Menu>
  );

  return (
    <div
      ref={toggleRef}
      className={`${styles.toggleWrapper} ${open ? styles.open : ''}`}
    >
      <PiUserThin
        size={20}
        className={styles.icon}
        onClick={() => {
          setOpen((o) => !o);
        }}
      />
      {open && createPortal(menu, document.body)}
    </div>
  );
};
